import React, { useEffect, useState } from 'react';
import { HomeIcon, UserIcon, ShieldIcon, AwardIcon, ClipboardListIcon, CalendarIcon, MailIcon } from 'lucide-react';
export function ScrollNav() {
  const [activeSection, setActiveSection] = useState('home');
  useEffect(() => {
    const sections = [{
      id: 'home',
      ref: document.getElementById('home')
    }, {
      id: 'about',
      ref: document.getElementById('about')
    }, {
      id: 'services',
      ref: document.getElementById('services')
    }, {
      id: 'qualifications',
      ref: document.getElementById('qualifications')
    }, {
      id: 'experience',
      ref: document.getElementById('experience')
    }, {
      id: 'availability',
      ref: document.getElementById('availability')
    }, {
      id: 'contact',
      ref: document.getElementById('contact-new')
    }];
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 200;
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = sections[i];
        if (section.ref && section.ref.offsetTop <= scrollPosition) {
          setActiveSection(section.id);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const scrollToSection = id => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };
  const navItems = [{
    id: 'home',
    label: 'Home',
    icon: <HomeIcon className="w-5 h-5" data-id="element-384" />
  }, {
    id: 'about',
    label: 'Over mij',
    icon: <UserIcon className="w-5 h-5" data-id="element-385" />
  }, {
    id: 'services',
    label: 'Diensten',
    icon: <ShieldIcon className="w-5 h-5" data-id="element-386" />
  }, {
    id: 'qualifications',
    label: 'Kwalificaties',
    icon: <AwardIcon className="w-5 h-5" data-id="element-387" />
  }, {
    id: 'experience',
    label: 'Ervaring',
    icon: <ClipboardListIcon className="w-5 h-5" data-id="element-388" />
  }, {
    id: 'availability',
    label: 'Tarieven',
    icon: <CalendarIcon className="w-5 h-5" data-id="element-389" />
  }, {
    id: 'contact-new',
    label: 'Contact',
    icon: <MailIcon className="w-5 h-5" data-id="element-390" />
  }];
  return <div className="hidden lg:block fixed right-4 top-1/2 transform -translate-y-1/2 z-50" data-id="element-391">
      <div className="bg-gray-800 rounded-full py-3 px-2 shadow-lg border border-gray-700" data-id="element-392">
        <div className="flex flex-col items-center space-y-4" data-id="element-393">
          {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className={`relative group rounded-full p-2 transition-all duration-300 ${activeSection === item.id ? 'bg-orange-500 text-white' : 'bg-gray-700 text-gray-400 hover:bg-gray-600'}`} aria-label={item.label} data-id="element-394">
              {item.icon}
              <span className="absolute right-full mr-2 top-1/2 transform -translate-y-1/2 px-2 py-1 rounded bg-gray-800 text-white text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-395">
                {item.label}
              </span>
              {activeSection === item.id && <span className="absolute -left-1 top-1/2 transform -translate-y-1/2 w-1 h-1 rounded-full bg-white" data-id="element-396"></span>}
            </button>)}
        </div>
      </div>
    </div>;
}